import React from 'react'
import { ChevronLeft, Star } from '@mui/icons-material'

/**
 * Legacy Super Bowl Squares UI: shown when circle is in legacySuperBowlSquaresGames.
 * Clean, minimalist design with white background and purple text.
 */
const SquaresLegacyView = ({ onBack }) => {
  return (
    <div className="flex flex-col px-2 sm:px-10 mt-10 flex-1">
      <button
        className="mb-10 w-fit items-center flex hover:opacity-80 transition duration-300 ease-in-out active:opacity-50 text-primary"
        onClick={onBack}
      >
        <ChevronLeft /> Return to event
      </button>

      <div className="flex flex-col items-center flex-1">
        <div className="flex flex-col items-center gap-4 flex-1">
          <div className="flex flex-col items-center">
            <div className="flex items-start justify-evenly w-full">
              <div className="flex flex-col items-center flex-[0.3]">
                <div className="w-10 h-10 rounded-sm border-[3px] border-square-primary" />
                <span className="text-[14px] font-semibold mt-2">Owner</span>
                <span className="text-[12px]">You own this square</span>
              </div>

              <div className="flex flex-col items-center flex-[0.3]">
                <div className="w-10 h-10 rounded-sm border-2 border-square-secondary bg-square-secondary" />
                <span className="text-[14px] font-semibold mt-2">Contender</span>
                <span className="text-[12px] text-center">
                  This square corresponds to the current score of the game.
                </span>
              </div>

              <div className="flex flex-col items-center flex-[0.3]">
                <div className="w-10 h-10 rounded-sm border-2 border-square-primary bg-square-primary flex items-center justify-center">
                  <Star style={{ color: 'white' }} />
                </div>
                <span className="text-[14px] font-semibold mt-2">Winner</span>
                <span className="text-[12px] text-center">
                  Your square won for the corresponding quarter.
                </span>
                <div className="flex gap-1 mt-1">
                  <span className="py-1 rounded-full bg-square-secondary text-[11px] text-square-primary w-[26px] text-center">
                    1st
                  </span>
                  <span className="py-1 rounded-full bg-square-secondary text-[11px] text-square-primary w-[26px] text-center">
                    2nd
                  </span>
                  <span className="py-1 rounded-full bg-square-secondary text-[11px] text-square-primary w-[26px] text-center">
                    3rd
                  </span>
                  <span className="py-1 rounded-full bg-square-secondary text-[11px] text-square-primary w-[26px] text-center">
                    4th
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-12 text-center max-w-lg">
              <h2 className="text-primary text-xl font-bold mb-4">
                Thanks for being part of the original Coteri Super Bowl Squares
                experience.
              </h2>
              <p className="text-primary text-[14px] mb-3">
                We've upgraded the platform, so square information from this game
                is no longer available.
              </p>
              <p className="text-primary text-[14px]">
                A new and improved Squares experience is available for future
                Super Bowls.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SquaresLegacyView
